import type { ReactNode } from "react"
import { useState } from "react"
import logoMarkUrl from "../assets/logo-mark.svg"
import { Link } from "./link"

export function AppShell({
  title,
  eyebrow,
  children,
  onLogout,
  showAdmin,
}: {
  title: string
  eyebrow: string
  children: ReactNode
  onLogout?: (() => void) | null
  showAdmin?: boolean
}) {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  const closeMobileNav = () => setMobileNavOpen(false)
  const pathname = typeof window === "undefined" ? "/app" : window.location.pathname
  const navClass = (href: string) => {
    const active = href === "/app" ? pathname === "/app" : pathname.startsWith(href)
    return active ? "app-nav-link app-nav-link--active" : "app-nav-link"
  }
  return (
    <div className={mobileNavOpen ? "app-shell app-shell--nav-open" : "app-shell"}>
      <button
        aria-label="Close navigation"
        className="app-nav-backdrop"
        type="button"
        onClick={closeMobileNav}
      />
      <aside className="app-sidebar">
        <Link href="/" className="brand-mark brand-mark--dark">
          <img src={logoMarkUrl} alt="" className="brand-mark__icon" aria-hidden="true" />
          <span>Adgiro</span>
        </Link>
        <nav className="app-nav">
          <Link href="/app" className={navClass("/app")} onClick={closeMobileNav}>
            Overview
          </Link>
          <Link href="/app/docs" className={navClass("/app/docs")} onClick={closeMobileNav}>
            Docs
          </Link>
          <Link href="/app/sites" className={navClass("/app/sites")} onClick={closeMobileNav}>
            Sites
          </Link>
          <Link href="/app/accounts" className={navClass("/app/accounts")} onClick={closeMobileNav}>
            Accounts
          </Link>
          {showAdmin ? (
            <Link
              href="/app/admin/users"
              className={navClass("/app/admin")}
              onClick={closeMobileNav}
            >
              Admin
            </Link>
          ) : null}
          <Link href="/app/settings" className={navClass("/app/settings")} onClick={closeMobileNav}>
            Settings
          </Link>
        </nav>
        {onLogout ? (
          <button type="button" className="button button--ghost app-logout" onClick={onLogout}>
            Log out
          </button>
        ) : null}
      </aside>
      <main className="app-main">
        <header className="app-page-header">
          <button
            aria-expanded={mobileNavOpen}
            aria-label="Open navigation"
            className="app-menu-button"
            type="button"
            onClick={() => setMobileNavOpen(true)}
          >
            <span />
            <span />
            <span />
          </button>
          <div>
            <div className="app-eyebrow">{eyebrow}</div>
            <h1 className="app-title">{title}</h1>
          </div>
        </header>
        {children}
      </main>
    </div>
  )
}
